function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "14",
  viewBox: "0 0 24 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "----icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "basics/icon/icon-transportation-4",
  transform: "translate(-8 -13)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 13.5c.697 0 1.372.232 1.919.657l.16.133 3.641 3.236 4.87.696a2.806 2.806 0 012.405 2.605L32 21v2a1.5 1.5 0 01-1.356 1.493l-.144.007h-1.55a2.5 2.5 0 01-4.9 0h-9.1a2.5 2.5 0 01-4.909-.046 2.362 2.362 0 01-1.512-1.009 3.155 3.155 0 01-.52-1.513L8 21.7V19c0-.4.068-.793.2-1.164l.008-.022c.091-.255.213-.5.362-.728l.13-.186 1.8-2.4a2.5 2.5 0 011.82-.993l.18-.007H19zm7.5 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-14 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.5-4H9.05a2.5 2.5 0 00-.042.298L9 19v.5h.5a.5.5 0 01.09.992l-.09.008H9v1.2c0 .423.126.838.361 1.19.171.257.42.445.706.54a2.499 2.499 0 014.883.07H17v-5zm7.471 0H18v5h6.05a2.501 2.501 0 012.286-1.995l.164-.005a2.5 2.5 0 012.45 2h1.55a.5.5 0 00.492-.41L31 23v-1.5h-1.5a.5.5 0 01-.09-.992l.09-.008h1.43a1.807 1.807 0 00-1.326-1.26l-.155-.028-4.978-.712zm-3.971 1a.5.5 0 01.09.992l-.09.008h-1a.5.5 0 01-.09-.992l.09-.008h1zm-6 0a.5.5 0 01.09.992l-.09.008h-1a.5.5 0 01-.09-.992l.09-.008h1zm-1.641-5H12.5a1.5 1.5 0 00-1.1.48l-.1.12-1.8 2.4h2.609l.75-3zm6.141 0h-1v3h5.185l-2.77-2.462a2.128 2.128 0 00-1.242-.531L19 14.5zm-2 0h-3.11l-.75 3H17v-3z",
  id: "icon"
})))));